export default "__VITE_ASSET__BM2ZYdBV__"